module.exports.getBuildEnvironment = function () {
  return process.env.GATSBY_BUILD_ENV;
};

module.exports.getIsSsr = function () {
  return process.env.NODE_ENV === 'production';
};

module.exports.getApiUrl = () => {
  const buildEnv = this.getBuildEnvironment();

  if (buildEnv === 'production') {
    return 'https://asite-api.andersenlab.com';
  }

  return 'https://dev-asite-api.andersenlab.com';
};
